<template>
  <page-outline 
    :title="listTitle"
    :show-filter="true"
    :show-refresh="true"
    :filter-expanded="displayFilter"
    :refresh-disabled="activateSpinner"
    @toggle-filter="toggleFilter"
    @refresh="refreshAlerts">
    <template slot="primaryActions">
      <app-button
        :text="$t('common.alerts.alert_configuration_add')"
        icon="fa-light fa-plus"
        variant="primary"
        @click="actionAdd">
      </app-button>
    </template>
    
    <template slot="filterContent">
      <app-panel
        :filters="filterConfig"
        :searchAriaLabel="$t('common.srch') + ' ' + $t('common.alerts.alert_configuration')"
        @filter-changed="onFilterChanged"
        @clear-filters="clearFilterFields"
        @apply-filters="applyFilters"
      />
    </template>
    
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <b-row class="mb-5">

          <!-- {{engineOptions}} -->
<!--          <b-col sm="6" lg="3" cols="12" class="filter-item-action mb-5">-->
<!--            <label class="filter-item-title text-ellipsis" for="metrickey">-->
<!--              {{ $t('common.alerts.engine') }}-->
<!--            </label>-->
<!--            <select class="filter-item-content" v-model="engineIndex" @change="getAlerts" id="enginekey"-->
<!--                    style="max-width:100%;padding:0.5rem;">-->
<!--              <option v-for="(engine, index) in engineOptions" :key="index" :value="index" :disabled="engine.disabled">-->
<!--                {{ engine.name }}-->
<!--              </option>-->
<!--            </select>-->
<!--          </b-col>-->
          <b-col cols="12">
            <div style="overflow:auto">
              <spinner v-if="activateSpinner"></spinner>
              <b-table v-else-if="listItemsAlerts.length > 0"
                :items="listItemsAlerts"
                :fields="fields"
                class="table-striped"
                hover
                :selectable="listItemsAlerts.length > 0"
                :empty-text="$t('common.security.no_result')"
                style="margin-bottom:0"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDir"
                @head-clicked="sortTable"
                @row-selected="onRowClicked"
                :key="refreshKey">
                <template #cell(MetricsKey)="data">
                  <span>{{ getMetricsKeyTranslation(data.value) }}</span>
                </template>
                <template #cell(ThresholdHigh)="data">
                  <span>{{ data.value }}</span>
                </template>
                <template #cell(ThresholdLow)="data">
                  <span>{{ data.value }}</span>
                </template>
                <template #cell(ThresholdUnit)="data">
                  <span>{{ data.value }}</span>
                </template>
                <template #cell(UpdatedAt)="data">
                  <span>{{ getDate(data.value) }}</span>
                </template>
                <template #cell(EmailGroupName)="data">
                  <span>{{ data.value }}</span>
                </template>
                <template #cell(Criticality)="data">
                  <span>{{ mapCriticalityToAlert(data.value) }}</span>
                </template>
                <template #cell(edit)="data">
                  <span class="text-center d-inline-block py-3 w-100" @click="actionEdit($event, data.item.IdAlerts)">
                    <i class="fa-regular fa-pencil"></i>
                  </span>
                </template>
                <template #cell(delete)="data">
                  <span class="text-center d-inline-block py-3 w-100" @click="actionDelete($event, data.item.IdAlerts)">
                    <i class="fa-regular fa-trash"></i>
                  </span>
                </template>
              </b-table>
              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t('common.no_result') }}
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col>
            <cm-pagination
              :maxResultsByPage="paginationObject.maxResults"
              :firstIndex="paginationObject.firstIndex"
              :nbResultsTotal="paginationObject.nbResultsTotal"
              :refreshEvent="paginationObject.refresh">
            </cm-pagination>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import Pagination from '@/components/common/pagination.vue'
import moment from 'moment-timezone'
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import AppButton from '@/components/common/AppButton.vue'
import AppCard from '@/components/common/AppCard.vue'
import AppPanel from '@/components/common/AppPanel.vue'
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"

export default {
  name: "AlertsPage",
  components: {
    'cm-pagination': Pagination,
    "form-write-group-label-input": formWriteGroupLabelInput,
    "page-outline": PageOutline,
    "app-button": AppButton,
    "app-card": AppCard,
    "app-panel": AppPanel,
    spinner: Spinner
  },
  props: {
    id: {
      type: String,
      default: "-1",
    },
  },
  data() {
    return {
      engineIndex: undefined,
      engineOptions: [],
      activateSpinner: false,
      displayFilter: false,
      elementSearchedEmailGroup: '',
      elementSearchedMetricsKey: '',
      emailGroupList: [],
      filterConditions: {},
      IdEmailGroupName: '',
      listItemsAlerts: [],
      listTitle: "",
      IdMetricsKey: '',
      metricsKeyList: [],
      filterValues: {
        IdMetricsKey: ''
      },
      pageCounter: 0,
      paginationObject: {},
      refreshKey: false,
      sortBy: '',
      sortDir: false,
      timezone: '+00:00'
    }
  },
  created() {
    this.timezone = moment.tz.guess()
    
    let that = this
    this.$engine.engines.forEach((engine, index) => {
      if (that.engineIndex === undefined && engine.common.network.state === 'online') {
        that.engineIndex = index
      }
      that.engineOptions.push({name:engine.common.network.info.name, disabled: engine.common.network.state === 'offline'})
    })
    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }

    this.listTitle = this.$i18n.t("common.alerts.alert_configuration")
    this.activateSpinner = true

    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.getAlerts(index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0

    this.getAlerts()
    // desactiver pour lot 1
    // this.getEmailGroups()
    this.getMetricsKey()

    if (this.id !== "-1") {
      this.tabName = parseInt(this.id)
    }
  },
  computed: {
    filterConfig() {
      const metricsOptions = this.metricsKeyList.map(key => ({
        value: key.id,
        label: this.getMetricsKeyTranslation(key.text)
      }))
      
      return [
        {
          id: 'filter-metrics-key',
          type: 'select',
          prop: 'IdMetricsKey',
          labelKey: 'common.alerts.metrics_key',
          icon: 'fa-solid fa-chart-line',
          value: this.filterValues.IdMetricsKey,
          defaultOptionKey: 'common.alerts.select_metrics_key',
          options: metricsOptions,
          colSm: '12',
          colLg: '12'
        }
      ]
    },
    canDelete () {
      return true
    },
    canEdit () {
      return true
    },
    fields () {
      let fields = []
      fields.push({
        key: 'Name',
        label: this.$t('common.alerts.name'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'MetricsKey',
        label: this.$t('common.alerts.metrics_key'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'ThresholdUnit',
        label: this.$t('common.alerts.threshold_unit'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'ThresholdLow',
        label: this.$t('common.alerts.threshold_low'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'ThresholdHigh',
        label: this.$t('common.alerts.threshold_high'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'UpdatedAt',
        label: this.$t('common.alerts.updated_at'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center p-2 py-3',
        sortable: true
      })
      // fields.push({
      //   key: 'EmailGroupName',
      //   label: this.$t('common.email.group_name'),
      //   thClass: 'text-center table-condensed-ipad',
      //   tdClass: 'p-0 text-center w-100 p-2 py-3',
      //   sortable: true
      // })
      fields.push({
        key: 'Criticality',
        label: this.$t('common.alerts.criticality_level'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center p-2 py-3',
        sortable: true
      })
      if (this.canEdit) {
        fields.push({ key: 'edit', label: this.$t('rights.edit'), thClass: 'text-center table-condensed-ipad', tdClass: 'p-0', sortable: false })
      }
      if (this.canDelete) {
        fields.push({ key: 'delete', label: this.$t('rights.delete'), thClass: 'text-center table-condensed-ipad', tdClass: 'p-0', sortable: false })
      }
      return fields
    }
  },
  methods: {
    getMetricsKeyTranslation(metricsKey) {
      // Try to translate with the key path first
      const translationKey = 'common.monitoring.key.' + metricsKey
      const translation = this.$t(translationKey)
      
      // If translation is not found (returns the key itself), return the original value
      if (translation === translationKey) {
        return metricsKey
      }
      
      return translation
    },
    actionAdd () {
      loadPage(this, {url: '/alerts/add/-1'})
    },
    actionDelete ($e, id) {
      $e.stopPropagation()
      let that = this
      this.$f7.modal({
        title: this.$t('common.alerts.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = { id: id }
              that.$engine.get(that.engineIndex).alerts.delete(params)
              .then(resp => {
                that.listItemsAlerts = that.listItemsAlerts.filter(item => item.IdAlerts !== id)
                that.$f7.modal({
                  title: that.$t('common.alerts.alert_configuration_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                // loadPage(that, { url: '/alerts/' + emailGroupId })
                loadPage(that, { url: '/alerts/' })
              })
              .catch(error => {
                if (error.code === 'ERR_NETWORK') {
                  that.engineOptions[that.engineIndex].disabled = true
                  for (let i = 0; i < that.engineOptions.length; i++) {
                    if (i !== that.engineIndex) {
                      that.engineIndex = i
                      break
                    }
                  }
                } else {
                  errorMessageAlert(error, that)
                  that.okMessageBox(that.$t('common.alerts.alert_configuration_delete_error'))
                }
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () { return }
          }
        ]
      })
    },
    actionEdit ($e, id) {
      $e.stopPropagation()
      loadPage(this, { url: '/alerts/edit/' + id })
    },
    applyFilter(filterConditions = {}) {
      this.filterConditions = filterConditions

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.getAlerts()
    },
    clearFilterFields() {
      this.IdEmailGroupName = ''
      this.IdMetricsKey = ''
      this.filterValues.IdMetricsKey = ''
      this.applyFilters()
    },
    onFilterChanged({ prop, value }) {
      this.filterValues[prop] = value
      if (prop === 'IdMetricsKey') {
        this.IdMetricsKey = value
      }
    },
    toggleFilter() {
      this.displayFilter = !this.displayFilter
    },
    refreshAlerts() {
      this.onRefresh()
    },
    applyFilters() {
      this.onRefresh()
    },
    getAlerts(index = 1) {
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      let that = this
      let params = {
        IdMetricsKey: this.IdMetricsKey,
        IdEmailGroupName: this.IdEmailGroupName,
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex
      }
      if (this.filterConditions.OrderByField) {
        params.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        params.OrderByDirection = this.filterConditions.OrderByDirection
      }
      this.$engine.get(this.engineIndex).alerts.fetch(params).then((resp) => {
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.Alerts.length

        let alertsList = {}

        alertsList = resp.data.Alerts

        that.updateAlerts(alertsList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        if (error.code === 'ERR_NETWORK') {
          that.engineOptions[this.engineIndex].disabled = true
          for (let i = 0; i < that.engineOptions.length; i++) {
            if (i !== that.engineIndex) {
              that.engineIndex = i
              break
            }
          }
        } else {
          errorMessageAlert(error, that)
        }
      })
    },
    getDate (date) {
      if (!date) return '-';

      // Si la date ne contient pas un offset explicite (+00:00, +04:00, etc.) ou 'Z', on suppose qu'elle est en UTC
      const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(date);
      const isoWithTZ = hasTimezone ? date : date + 'Z';

      return moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss');
    },
    getEmailGroups() {
      let params = { name: this.elementSearchedEmailGroup }
      let that = this
      this.$engine.firstOn().email.emailGroup.fetch(params).then((resp) => {
        this.emailGroupList = resp.data.EmailGroup.map(group => ({
          id: group.IdEmailGroup,
          text: group.GroupName,
          value: group.GroupName
        }))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getMetricsKey() {
      let params = { name: this.elementSearchedMetricsKey }
      let that = this
      this.$engine.get(this.engineIndex).monitoring.metricsKey.fetch(params).then((resp) => {
        const uniqueMetricsKey = new Set()
        this.metricsKeyList = resp.data.MetricsKey.filter((metricsKey) => {
          const isUnique = !uniqueMetricsKey.has(metricsKey.IdMetricsKey)
          uniqueMetricsKey.add(metricsKey.IdMetricsKey)
          return isUnique
        }).map((metricsKey) => ({
          id: metricsKey.IdMetricsKey,
          text: metricsKey.MetricsKey,
          value: metricsKey.MetricsKey
        })).sort((a, b) => a.text.localeCompare(b.text))
      })
      .catch(error => {
        if (error.code === 'ERR_NETWORK') {
          that.engineOptions[this.engineIndex].disabled = true
          for (let i = 0; i < that.engineOptions.length; i++) {
            if (i !== that.engineIndex) {
              that.engineIndex = i
              break
            }
          }
        } else {
          errorMessageAlert(error, that)
        }
      })
    },
    mapCriticalityToAlert(criticality) {
      if (criticality === '') {
        return ''
      }
      switch (Number(criticality)) {
        case 0:
          return this.$t('common.alerts.low')
        case 1:
          return this.$t('common.alerts.medium')
        case 2:
          return this.$t('common.alerts.high')
        case 3:
          return this.$t('common.alerts.critical')
        default:
          return ''
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    onRefresh() {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getAlerts()
    },
    onRowClicked(item) {
      if (item[0] && item[0].IdAlerts) {
        loadPage(this, { url: '/alerts/details/' + item[0].IdAlerts })
      }
    },
    sortTable (key, field, event, isFooter) {
      const sortableFields = [
        'Name',
        'MetricsKey',
        'ThresholdUnit',
        'ThresholdLow',
        'ThresholdHigh',
        'UpdatedAt',
        'Criticality'
      ]

      if (!sortableFields.includes(key)) {
        return
      }

      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    updateAlerts(alertsList) {
      this.listItemsAlerts = alertsList
    },
    viewEmailSender() {
      loadPage(this, { url: '/email/emailSender/-1' })
    },
  }
}
</script>

<style scoped>

@media (max-width: 1400px) {
  .responsive-button {
    min-height: 70px;
  }
}
</style>
